import type { ReactNode, RefCallback } from 'react'
import styled from 'styled-components'

interface Props {
  activationRef: RefCallback<HTMLDivElement>
  children: ReactNode
}

const StandaloneActivationSentinel = styled.span`
  display: block;
  height: 1px;
`

function StructuredFacilitiesReworkActivation({ activationRef, children }: Props) {
  return <div ref={activationRef}>{children}</div>
}

export function StructuredFacilitiesReworkStandaloneActivation({
  activationRef,
}: Pick<Props, 'activationRef'>) {
  return (
    <StructuredFacilitiesReworkActivation activationRef={activationRef}>
      <StandaloneActivationSentinel
        aria-hidden="true"
        data-testid="structured-facilities-rework-activation-sentinel"
      />
    </StructuredFacilitiesReworkActivation>
  )
}

export default StructuredFacilitiesReworkActivation
